import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useEffect } from 'react';

import { dadataGenderToCreditForm } from 'shared/lib';

import type { TPassportFormFields } from 'entities/creditForm';

// использовать только внутри контекста формы
export const useUpdateGender = () => {
  const { watch, setValue } = useFormContext<TPassportFormFields>();
  const fullName = watch('fullName');

  useEffect(() => {
    if (fullName?.data) {
      const { gender } = fullName.data;
      setValue('gender', dadataGenderToCreditForm(gender));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullName]);
};
